var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"express-checkout-loader"},[_c('el-button',{staticClass:"express-checkout-loader__btn",attrs:{"loading":true,"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }